import './FollowingFilter.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import React, { useCallback } from 'react';
const options = [
    {
        label: COPY_SPECIFIC.FOLLOWING,
        value: true
    },
    {
        label: `${COPY_SPECIFIC.NOT} ${COPY_SPECIFIC.FOLLOWING}`,
        value: false
    }
];
export const FollowingFilter = ({ disabled, onChange, value }) => {
    const handleOnChange = useCallback((isFollowing) => {
        onChange({ isFollowing });
    }, [onChange]);
    return (React.createElement(Select, { allowClear: true, className: 'following-filter', disabled: disabled, onChange: handleOnChange, options: options, placeholder: COPY_SPECIFIC.FOLLOWING, value: value }));
};
